import { render, staticRenderFns } from "./exportAnswer.vue?vue&type=template&id=5547f04c&scoped=true"
import script from "./exportAnswer.vue?vue&type=script&lang=js"
export * from "./exportAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5547f04c",
  null
  
)

export default component.exports